import { createContext } from 'react';

export const PrintModifiersContext = createContext({
  clearAllSelections: () => {},
  onPrint: () => {},
  deleteQueue: () => {},
  addPageRange: () => {},
});

export default PrintModifiersContext;
